/**
 * Fail-closed humanization for phone-auth-native error payloads (#510).
 * Kept pure so unit tests do not need React/Supabase — send-otp returns a
 * text body (JSON string) while verify-otp returns parsed JSON.
 */

export function parsePhoneAuthErrorPayload(payload: unknown): Record<string, unknown> {
  if (typeof payload === 'string') {
    try {
      const parsed: unknown = JSON.parse(payload);
      return parsed && typeof parsed === 'object'
        ? parsed as Record<string, unknown>
        : { error: payload };
    } catch {
      return { error: payload };
    }
  }

  return payload && typeof payload === 'object'
    ? payload as Record<string, unknown>
    : {};
}

export function humanizePhoneAuthError(payload: unknown, fallback: string): string {
  const body = parsePhoneAuthErrorPayload(payload);
  const code = String(body.error || body.code || '');
  const message = typeof body.message === 'string' ? body.message : '';

  switch (code) {
    case 'email_already_registered':
      return 'That email is already registered. Use the Login tab with your linked phone.';
    case 'phone_not_linked':
      return message || 'This number is not linked to an account yet. Ask an admin to link it, then use Login.';
    case 'rate_limited':
      return 'Too many attempts. Wait a minute and try again.';
    case 'otp_disabled':
    case 'Signups not allowed for otp':
      return 'No account found for this number yet. If you already joined, ask an admin to link your phone, then use Login.';
    default:
      if (/signups not allowed/i.test(code) || /signups not allowed/i.test(message)) {
        return 'No account found for this number yet. If you already joined, ask an admin to link your phone, then use Login.';
      }
      return message || code || fallback;
  }
}
